/*       */

import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';

/**
 * A countdown timer
 */
class CountdownTimer extends PureComponent {
    static propTypes = {
        seconds: PropTypes.number.isRequired,
        format: PropTypes.oneOf(['seconds', 'minutes']),
        onCountdownTerminated: PropTypes.func,
    };

    interval;
    state;
    hiddenAt = null;
    hiddenRemaining = null;

    /**
     * @param props the Component's properties.
     */
    constructor(props) {
        super(props);
        this.state = {
            secondsRemaining: props.seconds,
        };
        this.interval = setInterval(this.tick, 1000);
        document.addEventListener('visibilitychange', this.handleVisibilityChange);
    }

    tick = () => {
        if (this.state.secondsRemaining > 0) {
            this.setState(({ secondsRemaining }) => ({ secondsRemaining: secondsRemaining - 1 }));
        } else if (this.state.secondsRemaining === 0) {
            this.props.onCountdownTerminated && this.props.onCountdownTerminated();
            this.setState({ secondsRemaining: -1 });
        }
    };

    handleVisibilityChange = () => {
        if (document.visibilityState === 'hidden') {
            this.hiddenAt = Date.now();
            this.hiddenRemaining = this.state.secondsRemaining;
        } else if (document.visibilityState === 'visible' && this.hiddenAt) {
            const elapsed = Math.floor((Date.now() - this.hiddenAt) / 1000);
            const expectedRemaining = this.hiddenRemaining - elapsed;
            this.hiddenAt = null;
            this.hiddenRemaining = null;
            if (expectedRemaining <= 0) {
                this.props.onCountdownTerminated && this.props.onCountdownTerminated();
                this.setState({ secondsRemaining: -1 });
            } else if (this.state.secondsRemaining > expectedRemaining) {
                this.setState({ secondsRemaining: expectedRemaining });
            }
        }
    };

    /**
     * @override
     */
    componentDidUpdate(prevProps) {
        if (this.props.seconds !== prevProps.seconds) {
            this.hiddenAt = null;
            this.hiddenRemaining = null;
            this.setState({ secondsRemaining: this.props.seconds });
        }
    }

    /**
     * @override
     */
    componentWillUnmount() {
        clearInterval(this.interval);
        document.removeEventListener('visibilitychange', this.handleVisibilityChange);
    }

    /**
     * @override
     */
    render() {
        const format = this.props.format || 'seconds';
        const secondsRemaining = this.state.secondsRemaining > 0 ? this.state.secondsRemaining : 0;
        switch (format) {
            case 'seconds':
                return <span>{secondsRemaining}</span>;
            case 'minutes': {
                const minutes = Math.trunc(secondsRemaining / 60);
                const seconds = Math.trunc(secondsRemaining % 60);
                return (
                    <span>
                        {String(minutes).padStart(2, '0')}:{String(seconds).padStart(2, '0')}
                    </span>
                );
            }
            default:
                throw new Error(`Unhandled format "${format}".`);
        }
    }
}

export default CountdownTimer;
